import React, { useState, useEffect } from "react";
import "./DepositCrypto.css";
import Header from "../../../components/header/Header";
import { ReactComponent as CopyBold } from "../../../assets/icons/depositCrypto/depostCopyBold.svg";
import Button from "../../../components/button/Button";
import QRCode from "react-qr-code";
import { enqueueSnackbar } from "notistack";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DepositCrypto = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedCoin, setSelectedCoin] = useState("");
  const [depositAmount, setDepositAmount] = useState("");
  const [depositAddress, setDepositAddress] = useState("");
  const [availableCoins, setAvailableCoins] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const [statusDepost, setStatusDeposit] = useState(false) // true - значит кинули заявку на пополнение и ожидается оплата по адресу // false значит пользователь выбирает бан и сумму а после должен нажать "пополнить"

  // Функция для копирования адреса
  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() =>
        enqueueSnackbar(t("depositCrypto.copyAddress"), {
          autoHideDuration: 3000,
          variant: "success",
        })
      )
      .catch(() =>
        enqueueSnackbar(t("depositCrypto.errorCopyAddress"), {
          autoHideDuration: 3000,
          variant: "error",
        })
      );
  };

  const transformCryptoData = (data) => {
    const result = [];

    // Проходим по ключам объекта
    for (let i = 1; i <= 5; i++) {
      if (data[`cryptoEnabled${i}`]) {
        result.push({
          [`cryptoTransferVar`]: data[`cryptoTransferVar${i}`],
          [`cryptoNet`]: data[`cryptoNet${i}`],
          [`cryptoCardNumber`]: data[`cryptoCardNumber${i}`],
        });
      }
    }

    return result;
  };

  // Получение списка доступных криптовалют
  const fetchCoinsAndAddress = async () => {
    setLoading(true);
    axios
      .get(`https://api-ru.fynex.cc/api/api/crypto/avilable`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setAvailableCoins(transformCryptoData(res.data));
        setLoading(false);
      });
  };

  // Обновляем адрес депозита при изменении выбранной криптовалюты
  useEffect(() => {
    if (selectedCoin) {
      const coinData = availableCoins.find(
        (coin) => coin.cryptoTransferVar === selectedCoin
      );
      setDepositAddress(coinData.cryptoCardNumber || ""); // Если не найдено, будет пустая строка
    }
  }, [selectedCoin]);

  // Загружаем данные при монтировании
  useEffect(() => {
    fetchCoinsAndAddress();
  }, []);

  const handleDeposit = () => {
    if (!selectedCoin || !depositAmount) {
      enqueueSnackbar(t("depositCrypto.selectCoinError"), {
        autoHideDuration: 3000,
        variant: "error",
      });
      return;
    }
    if(statusDepost == true){
      navigate("../deposit-approve")
    }else{
      axios
        .post(
          `https://api-ru.fynex.cc/api/api/users/balance/refill/crypto`,
          {
            balance_type: "main",
            value: depositAmount,
            coin_to: selectedCoin,
            coin_from: selectedCoin,
            owner_details: "string",
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          setStatusDeposit(true)
        })
        .catch((error) => {
          error.response.data.detail.map((errormsg) => {
            enqueueSnackbar(`${t("depositCrypto.error")}: ${errormsg.msg}`, {
              variant: "error",
              className: "snackerror",
            });
          });
        });
      }
  };

  return (
    <div className="DepositCrypto">
      <Header hasMenu2={true} />
      <div className="DepositCryptoWrapper">
        {
          statusDepost == false ?
            <div className="inputBlock">
              <h2>{t("depositCrypto.title")}</h2>
              <div className="inputs">
                <select
                  value={selectedCoin}
                  onChange={(e) => setSelectedCoin(e.target.value)}
                >
                  {loading ? (
                    ""
                  ) : (
                    <option value="" disabled>
                      {t("depositCrypto.selectCoin")}
                    </option>
                  )}
                  {loading ? (
                    <option value="" disabled>
                      {t("depositCrypto.loading")}
                    </option>
                  ) : (
                    availableCoins.map((coin) => (
                      <option
                        key={coin.cryptoTransferVar}
                        value={coin.cryptoTransferVar}
                      >
                        {coin.cryptoTransferVar.toUpperCase()} ({coin.cryptoNet})
                      </option>
                    ))
                  )}
                </select>
                <input
                  type="text"
                  placeholder={t("depositCrypto.SumInput")}
                  value={depositAmount}
                  onChange={(e) => setDepositAmount(e.target.value.replace(/[^0-9.]+|(?<!\d)\.(?!\d)|(?<=\d)\.(?=\D)/g, '').trim())}
                />
              </div>
            </div>
              :
              <div className="transferAdrdess">
              <h2>{t("depositCrypto.depositAddress")}</h2>
              <div className="transferAdrdessWrapper">
                {depositAddress ? (
                  <>
                    <div className="qrcodeWrapper">
                      <QRCode value={depositAddress} className="qrcodeCrypto" />
                    </div>
                    <h2 onClick={() => handleCopy(depositAddress)}>
                      {depositAddress} <CopyBold />
                    </h2>
                    <p>{t("depositCrypto.checkAddress")}</p>
                  </>
                ) : (
                  <p>{t("depositCrypto.selectCoinADRESS")}</p>
                )}
              </div>
            </div>
            }
          <Button
            text={t("depositCrypto.depositButton")}
            onClick={handleDeposit}
          />
      </div>
    </div>
  );
};

export default DepositCrypto;
